import React from 'react';

import './IconLabel.less';

type IconLabelProps = {
  icon: React.ReactNode;
  label: React.ReactNode;
  gap?: number;
  direction?: 'horizontal' | 'vertical';
};

function IconLabel({ icon, label, gap = 0, direction = 'horizontal' }: IconLabelProps) {
  return (
    <div className={`IconLabel-${direction}-container`} style={{ gap }}>
      <div className="icon-container">{icon}</div>
      {label}
    </div>
  );
}

export default IconLabel;